import styled, { css } from 'styled-components';

import { SubgroupColor } from '../../../../interfaces';

interface CellContainerProps {
  cellPadding: number;
  minWidth?: number;
  width?: number | string;
  cellBorderColor?: string;
}

interface RowItemsProps {
  rowHeight: number;
  parentExpanded?: boolean;
  subLevelNumber: number;
  subgroupColor?: SubgroupColor;
}

export const RowItem = styled.tr<RowItemsProps>`
  display: flex;
  height: ${({ rowHeight }) => `${rowHeight}px`};
  background-color: ${({
  parentExpanded,
  theme,
  subLevelNumber,
  subgroupColor,
}) =>
    parentExpanded && subgroupColor?.active
      ? `${subgroupColor.color || theme.colors.black}${subLevelNumber * 10}`
      : 'transparent'};
`;

export const CellContainer = styled.td<CellContainerProps>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-family: ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  border-bottom: 1px solid
    ${({ cellBorderColor }) => cellBorderColor || '#ececec'};
  padding: ${({ cellPadding }) => `${cellPadding}px`};
  ${({ minWidth, width }) => css`
    min-width: ${minWidth ? `${minWidth}px` : `${width}px`};
    width: ${width ? `${width}px` : '100%'};
  `}
`;
